import { Link, NavLink } from "react-router-dom";
import { T } from "@/lib/theme";

const LINKS = [
  { to: "/",             label: "Arrival",      key: "arrival" },
  { to: "/brand",        label: "The Brand",    key: "brand" },
  { to: "/orbit",        label: "Orbit",        key: "orbit" },
  { to: "/capabilities", label: "Capabilities", key: "capabilities" },
  { to: "/contact",      label: "Contact",      key: "contact" },
];

export default function SiteHeader() {
  return (
    <header className="sticky top-0 z-40 backdrop-blur-md" data-testid="site-header"
      style={{ background: `${T.bg}E6`, borderBottom: `1px solid ${T.border}`, color: T.text }}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <Link to="/" data-testid="site-wordmark"
          className="inline-flex items-baseline gap-2 font-bricolage font-semibold uppercase"
          style={{ color: T.text, letterSpacing: "0.22em", fontSize: 14 }}>
          <span style={{ color: T.warm }}>E</span>
          <span>renown</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <NavLink
              key={l.key}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.key}`}
              style={({ isActive }) => ({
                color: isActive ? T.accent : T.mutedSoft,
                fontFamily: "IBM Plex Mono, monospace",
                fontSize: 11,
                letterSpacing: "0.24em",
                textTransform: "uppercase",
                transition: "color 0.2s",
                paddingBottom: 2,
                borderBottom: isActive ? `1px solid ${T.accent}` : "1px solid transparent",
              })}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:block w-px h-4" aria-hidden />
      </div>

      {/* mobile nav */}
      <div className="md:hidden border-t" style={{ borderColor: T.border }}>
        <div className="max-w-[1400px] mx-auto px-4 py-3 flex items-center gap-4 overflow-x-auto no-scrollbar">
          {LINKS.map((l) => (
            <NavLink
              key={l.key}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-mobile-${l.key}`}
              className="flex-shrink-0"
              style={({ isActive }) => ({
                color: isActive ? T.accent : T.mutedSoft,
                fontFamily: "IBM Plex Mono, monospace",
                fontSize: 11,
                letterSpacing: "0.22em",
                textTransform: "uppercase",
              })}
            >
              {l.label}
            </NavLink>
          ))}
        </div>
      </div>
    </header>
  );
}
